import {
  FaroChip,
  FaroChipProps,
  grey,
  NO_TRANSLATE_CLASS,
} from "@faro-lotv/flat-ui";
import type { JSX } from "react";
import { AI_GRADIENT, AI_GRADIENT_BASE_COLOR } from "./ai-gradients";

type FaroAiChipProps = Pick<
  FaroChipProps,
  "label" | "size" | "textTransform" | "onClick" | "disabled" | "tooltip"
>;

/** @returns a specialized chip component for AI-generated tags with gradient styling */
export function FaroAiChip({
  label,
  size = "medium",
  textTransform = "capitalize",
  onClick,
  disabled,
  tooltip,
}: FaroAiChipProps): JSX.Element {
  return (
    <FaroChip
      className={NO_TRANSLATE_CLASS}
      label={label}
      textTransform={textTransform}
      size={size}
      onClick={onClick}
      disabled={disabled}
      tooltip={tooltip}
      color={grey[0]}
      backgroundColor={AI_GRADIENT_BASE_COLOR}
      sx={{
        ...AI_GRADIENT,
        transition: "filter 150ms",
        // The gradient is opaque, so MUI's hover background color would never show through.
        "&.MuiChip-clickable:hover": { filter: "brightness(0.95)" },
      }}
    />
  );
}
